import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Miniplayer from './Miniplayer/Miniplayer';
import initSentry from './sentry';
import * as serviceWorker from './serviceWorker';

initSentry();

ReactDOM.render(<Miniplayer />, document.getElementById('NPOMiniplayer'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
